import { render, staticRenderFns } from "./appointDialog.vue?vue&type=template&id=3fbc861a&scoped=true&"
import script from "./appointDialog.vue?vue&type=script&lang=js&"
export * from "./appointDialog.vue?vue&type=script&lang=js&"
import style0 from "./appointDialog.vue?vue&type=style&index=0&id=3fbc861a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc861a",
  null
  
)

export default component.exports